import React, { Component } from "react";
import { Link } from "react-router-dom";
import Localization from "../localization/localization"
import TiktokPixel from 'tiktok-pixel';

class Landing extends Component {

  constructor() {
    super();
    this.locale = Localization.getLocalizationInstance(localStorage.getItem("exmi_language"));

    ///  Pixel Tiktok
    const advancedMatching = {
    }; 
    
    const options = {
      debug: false, // enable logs
    };
    
    TiktokPixel.init('CI5IPI3C77U441D0TRH0', advancedMatching, options);
    
    TiktokPixel.pageView(); // For tracking page view
    ////////
  }

  render() {
    return (
      <div class="col s12 m12 l8 container">
          <div class="col s12 l10 offset-l1 center contentaligned valign-wrapper">
          <div>
            <div className="font-face-mb titulo">
              <h3>
                {this.locale.layout_landing_label_welcome} <br></br> {this.locale.layout_landing_label_eventname}{" "}
                {this.locale.layout_landing_label_envenname_year}
              </h3>
            </div>
            <br></br>
            <div class="subTitulo">
              <h6>
                {this.locale.layout_landing_label_recomendation_message}
              </h6>
            </div>
            <div className="divSpaces"></div>
            <div className="col s12 m12 l6 paddingButtons">
            <div class="container">
        <div class="header">
            <h5>{this.locale.dashboard_dashboard_label_message_registryconfirmation_non_buyer_0}</h5>
        </div>
        <div class="content">
            <p>{this.locale.buyer_message}</p>
              <Link
                to="/prelogin"
                style={{
                  width: "250px",
                  borderRadius: "3px",
                  letterSpacing: "1.5px",
                  marginTop: "1rem"
                }}
                className="btn-large hoverable buttonBackgroundColor"
              >
                {this.locale.layout_landing_label_register_here}
              </Link>
        </div>
    </div>
            </div>

            <div className="col s12 m12 l6 paddingButtons">
            <div class="container">
        <div class="header">
            <h5>{this.locale.auth_visitante_label}</h5>
        </div>
        <div class="content">
        <p>{this.locale.visitor_message}</p>
              <Link
                to="/rules/visitante"
                style={{
                  width: "250px",
                  borderRadius: "3px",
                  letterSpacing: "1.5px",
                  marginTop: "1rem"
                }}
                className="btn-large hoverable buttonBackgroundColor"
              >
                {this.locale.layout_landing_label_register_here}
              </Link>
        </div>
    </div>
            </div>
            </div>
          </div>
        </div>
    );
  }
}

export default Landing;